import {$dom} from '../../helpers/dom';
import Choices from 'choices.js';
import variables from '../../variables';
import {$data} from '../../helpers/data';
import is from 'is_js';

const {
	exist,
	attr,
	callAll
} = $dom;

const {merge} = $data;

export default function createChoices(
	selectSelector = variables.selectors.customSelectSelector
) {


	if (exist(selectSelector)) {
		const {commonChoiceOpts, multipleChoiceOpts} = variables;
		const
			init = () => {
				callAll(selectSelector, s => {
					const isMultiple = is.not.null(attr(s, 'multiple'));
					s.choices = new Choices(s, merge(commonChoiceOpts, isMultiple ? multipleChoiceOpts : {}))
				})
			},
			destroy = () => callAll(selectSelector, s => s.choices instanceof Choices && s.choices.destroy())
		;

		return {init, destroy}
	}
	return null;
}
